'use client'

import { CouponCard, CouponModel, useAvailableCouponQuery } from '@entities/coupon'
import { sortAvailableCoupons } from '@features/coupon'
import { useTranslation } from '@shared/config/i18n'
import { UI_IDS } from '@shared/constants'

import { BottomSheetTrigger, ButtonV1, Flex, Typography } from '@podo-app/design-system-temp'
import { PodoEmpty1Icon } from '@podo/assets'

const AvailableCoupons = () => {
  const { data: coupons } = useAvailableCouponQuery()

  if (coupons?.length === 0) {
    return <EmptyAvailableCoupon />
  }

  return (
    <Flex direction="vertical" className="items-center gap-2" data-testid="list-coupons">
      {sortAvailableCoupons(coupons ?? [])?.map((coupon) => {
        const couponModel = CouponModel.create(coupon)

        if (!couponModel.isAvailable) {
          return null
        }

        return (
          <CouponCard
            status={
              couponModel.plain.displayStatus as Extract<typeof couponModel.plain.displayStatus, 'NORMAL' | 'PENDING'>
            }
            isPercentageDiscount={couponModel.isPercentageDiscount}
            key={coupon.couponId}
            title={couponModel.plain.title}
            discountType={couponModel.discountType}
            discountAmount={couponModel.plain.discountAmount}
            discountAmountMax={couponModel.plain.discountAmountMax}
            isMaximumDiscount={couponModel.isMaximumDiscount}
            id={coupon.couponId}
            useStartedAt={couponModel.couponDisplayStartedAt}
            useEndedAt={couponModel.plain.utcUseEnd}
            isSubscribePayment={couponModel.isSubscribePayment}
            remainingTimeType={couponModel.remainingTimeType}
          />
        )
      })}
    </Flex>
  )
}

export default AvailableCoupons

const EmptyAvailableCoupon = () => {
  const t = useTranslation()

  return (
    <Flex direction="vertical" className="items-center" data-testid="empty-coupons">
      <Flex direction="vertical" className="items-center gap-12 mt-20 mb-12">
        <PodoEmpty1Icon />
        <Typography size="body1" className="text-gray-400 text-center">
          {t('coupon.empty.availableLine1')}
          <br />
          {t('coupon.empty.availableLine2')}
        </Typography>
      </Flex>

      <BottomSheetTrigger asChild>
        <ButtonV1
          size="large"
          data-testid="btn-register-coupon-empty"
          eventParams={{ name: UI_IDS.btn.registerCouponEmpty, location: 'coupon', action: 'open' }}
        >
          {t('coupon.actions.register')}
        </ButtonV1>
      </BottomSheetTrigger>
    </Flex>
  )
}
